import { validateEmail } from '../../../../utils/validator';
/**
 * Function de validation des commandes
 * @param  {object} values values du formulaire
 */
const validate = values => {
  const errors = {
    recipient: {}
  };
  if (values.recipient) {
    if (!values.recipient.lastname) {
      errors.recipient.lastname = 'Champ requis';
    }
    if (!values.recipient.firstname) {
      errors.recipient.firstname = 'Champ requis';
    }
    if (!values.recipient.phoneNumber) {
      errors.recipient.phoneNumber = 'Champ requis';
    }
    if (!values.recipient.email) {
      errors.recipient.email = 'Champ requis';
    }
    if (!validateEmail(values.recipient.email)) {
      errors.recipient.email = 'Adresse email invalide';
    }
    if (!values.recipient.street) {
      errors.recipient.street = 'Champ requis';
    }
    if (!values.recipient.city) {
      errors.recipient.city = 'Champ requis';
    }
    if (!values.recipient.postalCode) {
      errors.recipient.postalCode = 'Champ requis';
    }
  }
  return errors;
};

export default validate;
